export class EditorAddModel {
    public firstName: number;
    public lastName: string;
    public email: string;
    public phoneNumber: string;
    public password: string;
    public cpassword: string;
}
